import { render, staticRenderFns } from "./object-viewer.vue?vue&type=template&id=034de8ac&scoped=true&"
import script from "./object-viewer.vue?vue&type=script&lang=js&"
export * from "./object-viewer.vue?vue&type=script&lang=js&"
import style0 from "./object-viewer.vue?vue&type=style&index=0&id=034de8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034de8ac",
  null
  
)

export default component.exports